import { useState, useEffect, useRef } from 'react';

export const ActiveTab = {
  summary: 'summary',
  lab: 'lab',
  actions: 'actions',
};

const SECTION_POSITION_OFFSET = 200;

const handleLinks = (data) => {
  const { description, labResults, recommendedActions } = data;

  let links = [];

  if (description) {
    links.push({
      textId: 'app.summary',
      sectionsId: ActiveTab.summary,
    });
  }
  if (labResults && labResults.length > 0) {
    links.push({
      textId: 'test-result.lab-results',
      sectionsId: ActiveTab.lab,
    });
  }
  if (recommendedActions) {
    links.push({
      textId: 'app.recommended-actions',
      sectionsId: ActiveTab.actions,
    });
  }

  return links;
};

const useScrollHandlerForTestosteroneCheck = ({ data }) => {
  const linksData = handleLinks(data);
  const [activeSection, setActiveSection] = useState(linksData[0].sectionsId);

  const scrollableElementRef = useRef(null);

  const handleScroll = (scrollTop) => {
    const summaryScrollPosition = document.getElementById('summary')?.offsetTop;
    const labResultsPosition = document.getElementById('lab')?.offsetTop;
    const recommendedActionsPosition =
      document.getElementById('actions')?.offsetTop;

    const positions = [
      { id: ActiveTab.summary, position: summaryScrollPosition },
      { id: ActiveTab.lab, position: labResultsPosition },
      { id: ActiveTab.actions, position: recommendedActionsPosition },
    ].filter((pos) => pos.position !== undefined);

    positions.sort((a, b) => a.position - b.position);

    for (let i = 0; i < positions.length; i++) {
      const { id, position } = positions[i];
      //TODO: for now this, later we change it so we dont use Infinity
      const nextPosition = positions[i + 1]?.position ?? Infinity;

      if (
        scrollTop >= position - SECTION_POSITION_OFFSET &&
        scrollTop < nextPosition - SECTION_POSITION_OFFSET
      ) {
        if (activeSection !== id) {
          setActiveSection(id);
        }
        break;
      }
    }
  };

  useEffect(() => {
    const scrollableElement = scrollableElementRef.current;

    const handleScrollEvent = () => {
      handleScroll(scrollableElement?.scrollTop, activeSection);
    };

    if (scrollableElement) {
      scrollableElement.addEventListener('scroll', handleScrollEvent);
    }

    return () => {
      if (scrollableElement) {
        scrollableElement.removeEventListener('scroll', handleScrollEvent);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSection]);

  return {
    scrollableElementRef,
    activeSection,
    linksData,
  };
};

export default useScrollHandlerForTestosteroneCheck;
